import axios from 'axios';

export async function validateLoggedIn() {
  const requestBody = {
    query: `
    query {
      checkSession
      {
        isLoggedIn,
        timeLeft,
        email,
        userId,
      }
  }`,
    queryName: 'check_session',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}

export async function logout() {
  const requestBody = {
    query: `
    query {
      logout
      { 
        isLoggedIn
      }
  }`,
    queryName: 'sign_out',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}
